export const countPunctuation = (text: string) => {
  return text.length - text.replace(/[\.\!\?]/g, '').length
}
